(() => {
  const header = document.querySelector('.site-header');
  const setHeader = () => header?.classList.toggle('is-scrolled', scrollY > 28);
  setHeader(); addEventListener('scroll', setHeader, {passive:true});
  document.querySelectorAll('[data-reveal]').forEach(el => new IntersectionObserver(entries => entries.forEach(entry => {
    if(entry.isIntersecting) entry.target.classList.add('is-visible');
  }), {threshold:.12}).observe(el));
  document.querySelectorAll('[data-quantity]').forEach(form => {
    const input = form.querySelector('input'); form.querySelectorAll('button').forEach(btn => btn.addEventListener('click', () => {
      input.value = Math.max(1, Number(input.value) + Number(btn.dataset.quantity)); input.dispatchEvent(new Event('change'));
    }));
  });
  document.documentElement.classList.add('js');
})();

